import { Eye, Pencil } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { Badge } from '@/components/ui/badge'

export function PermissionBadge({ permission }: { permission: 'read' | 'read_write' }) {
  const { t } = useTranslation()
  const readWrite = permission === 'read_write'
  return (
    <Badge
      variant="outline"
      className={
        readWrite ? 'text-xs border-info-border bg-info-surface text-info-foreground' : 'text-xs'
      }
    >
      {readWrite ? (
        <>
          <Pencil className="h-3 w-3 mr-1" />
          {t('settings.access.dataLake.readWrite')}
        </>
      ) : (
        <>
          <Eye className="h-3 w-3 mr-1" />
          {t('settings.access.dataLake.readOnly')}
        </>
      )}
    </Badge>
  )
}
